import {createSelector} from 'reselect';

import {report as reportState} from './root.selector';

// Get allReportState object
export const allReportState = createSelector(
  reportState,
  state => state?.allReportState ?? {},
);

// Get the REPORT_WATCH_LIST object
export const reportWatchList = createSelector(
  allReportState,
  state => state?.REPORT_WATCH_LIST ?? {},
);

// Get watchListIds object
export const watchListIds = createSelector(
  reportWatchList,
  state => state?.watchListIds ?? {},
);

// downlineCoachIds array
export const downlineCoachIds = createSelector(
  watchListIds,
  state => state?.downlineCoachIds ?? [],
);

// helper function to check if coach is in watchlist
export const coachIdById = createSelector(
  downlineCoachIds,
  (ids: number[]) => (coachId: number) => ids.includes(coachId),
);

// watchlist count
export const watchlistCount = createSelector(
  watchListIds,
  state => state?.count ?? 0,
);
